export default "__VITE_ASSET__DFB1OQZA__"